import { useEffect } from 'react';
import { useTranslation } from '../../hooks/useTranslation';

/**
 * Component to update document title and meta tags based on current language
 */
const DocumentHead = () => {
  const { t, language } = useTranslation();

  useEffect(() => {
    // Update document title
    document.title = t('siteTitle');
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', t('siteDescription'));
    }
    
    // Update html lang attribute
    document.documentElement.lang = language;
  }, [t, language]);

  return null;
};

export default DocumentHead;

